import React, { useCallback, useContext, useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import style from './stylesheets/NavbarStyle.module.css';
import logo from '../images/mainlogo.jpg';
import api from '../apis/api';

import { userContext } from '../App';

const Navbar = () => {
    const { state } = useContext(userContext);
    const history = useHistory();
    const [searchname, setquery] = useState('');
    const [showSearch,setSearch] = useState([]);
    const [user,setUser] = useState('');

    const HandelSearch = (e) => {
        e.preventDefault();
        console.log((searchname));
        setSearch([]);
        setquery('');
        history.push('/products',searchname);
    } 

    const Event = (e) =>{
        let value = e.target.innerText;
        setquery(value);  
    }

    const Showmenu = () =>{
        let user = document.getElementById('toggle_user');
        user.style.display = "block";
    }

    const Hidemenu = () =>{
        let user = document.getElementById('toggle_user');
        user.style.display = "none";
    }
    const getuserDetails = useCallback(async ()=>{
        if(state){
            try {
                const response = await api.get('/');
                const user = await response.data.user;
                setUser(user);
            } catch (error) {
                console.log(error);
            }
        }
    },[state]);

    const Search = useCallback(async () =>{
        try {
            const response = await api.get('/autocomplete/',{params:{searchname}});
            const data = await response.data;
            const uniqueChars = [...new Set(data)];

            setSearch(uniqueChars);

        } catch (error) {
            console.log(error);
        }
    },[searchname]);

    useEffect(() =>{
        getuserDetails();
        Search();
    },[getuserDetails,Search]);

    return (
        <>
            <nav className={style.navbar}>
                <div className={style.logo}>
                    <img src={logo} alt="logo" />
                </div>
                <ul>
                    <li>
                        <NavLink className={style.nav_link} to='/'>Home</NavLink>
                    </li>
                    <li>
                        <NavLink className={style.nav_link} to='/products'>Products</NavLink>
                    </li>
                    <li>
                        <NavLink className={style.nav_link} to='/sales'>Sales</NavLink>
                    </li>
                    <li>
                        <NavLink className={style.nav_link} to='/about'>About</NavLink>
                    </li>
                    <li>
                        <NavLink className={style.nav_link} to='/support'>Support</NavLink>
                    </li>
                </ul>
                <div className={style.box}>
                    <form className={style.searchbox} method='GET'>
                        <input type="search" name="searchBox" id="searchquery" placeholder="Search Here..." value={searchname} onChange={(e) => setquery(e.target.value)} />
                        <button className={style.search} type="submit" onClick={HandelSearch}><i className="fa fa-search"></i></button>
                        <div className={style.autocomplete}>
                            {
                                showSearch.map((val,index)=>{
                                    return(
                                        <p key={index} value={val} onClick={Event}>{val}</p>
                                    )
                                })
                            }
                        </div>
                    </form>
                    {state
                    ? 
                    <>
                    <div className={style.hidemenu}>
                        
                    <NavLink className={style.vav} to='/checkout'>
                        <button className={style.btn}><i class="fa fa-shopping-bag"></i></button>
                    </NavLink>
                        <button className={style.btn} onMouseEnter={Showmenu}><i class="fa fa-user-circle-o" aria-hidden="true"></i></button>
                        <div className={style.showmenu} onMouseLeave={Hidemenu} id="toggle_user" >
                            <ul>
                                <li>
                                <i class="fa fa-id-badge"> <span style={{color:'darkblue'}}>Hello {user}</span> </i>
                                </li>
                                <li>
                                <i title='Your Cart' class="fa fa-briefcase"></i> your orders
                                </li>
                                <li>
                                    <NavLink className={style.logout} to='/signout'><i className="fa fa-sign-out">Logout</i></NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    </> 
                    : 
                    <>
                    <NavLink className={style.vav} to='/signup'>
                        <button className={style.btn}>Creat an Account</button>
                    </NavLink>
                    <NavLink className={style.vav} to='/login'>
                        <button className={style.btn}>Login</button>
                    </NavLink>
                    </>}
                </div>
            </nav>
        </>
    )
}

export default Navbar;
